import React from "react";
import { useDropzone } from "react-dropzone";
import Button from "../../../component/button";

const ImportAllButton = (props) => {
  const { t, importAll } = props;

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: { "application/json": [".json"] },
    maxSize: 10 * 1024 * 1024, // 10 MB
    multiple: false,
    onDropAccepted: (acceptedFiles) => {
      if (acceptedFiles && acceptedFiles.length > 0) {
        importAll(acceptedFiles);
      }
    },
    onDropRejected: (fileRejections) => {
      if (props.onFilesError) props.onFilesError(fileRejections);
    },
  });

  return (
    <div
      {...getRootProps()}
      className="files-dropzone"
      style={{ display: "inline-block" }}
    >
      <input {...getInputProps()} />
      <Button className="buttonSecondary">
        {isDragActive ? t("DROP_FILE_HERE") : t("Import")}
      </Button>
    </div>
  );
};

export default ImportAllButton;
